import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Rightchat from "../components/Rightchat";
import Popupchat from "../components/Popupchat";
import Appfooter from "../components/Appfooter";
import Postview from "../components/Postview";

import { fetchPosts } from "../redux/slices/postSlice";
import { RootState } from "../redux/store";

const UPLOAD_URL = (process.env.REACT_APP_UPLOAD_URL || "")
  .replace(/\/uploads\/?$/, "")
  .replace(/\/$/, "");

const getUploadUrl = (file?: string) => {
  if (!file) return undefined;

  if (file.startsWith("http://") || file.startsWith("https://")) {
    return file;
  }

  if (file.startsWith("/uploads/")) {
    return `${UPLOAD_URL}${file}`;
  }

  return `${UPLOAD_URL}/uploads/${file}`;
};

const stripHtml = (html = "") =>
  html.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

const News: React.FC = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();

  const { posts, loading } = useSelector((state: RootState) => state.posts);

  useEffect(() => {
    dispatch(fetchPosts());
  }, [dispatch]);

  const allPosts = posts || [];

  return (
    <>
      <Header />
      <Leftnav />
      <Rightchat />

      <div className="main-content right-chat-active social-home-content">
        <div className="middle-sidebar-bottom">
          <div className="middle-sidebar-left social-feed-wrapper">
         
            {loading ? (
              <div className="social-feed-state">Loading posts...</div>
            ) : allPosts.length > 0 ? (
              <div className="social-feed-list">
                {allPosts.map((post: any) => (
                  <div
                    key={post.post_id}
                    onClick={(e) => {
                      const target = e.target as HTMLElement;

                      if (
                        target.closest("button") ||
                        target.closest("a") ||
                        target.closest("iframe") ||
                        target.closest("video") ||
                        target.closest(".post-actions") ||
                        target.closest(".like-button") ||
                        target.closest(".comment-button") ||
                        target.closest(".share-button")
                      ) {
                        return;
                      }

                      navigate(`/news-details/${post.post_id}`, {
                        state: { post },
                      });
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <Postview
                      id={post.post_id}
                      clientId={post.client_id}
                      user={post.client_name || "News Source"}
                      role={post.client_user_role || post.role || ""}
                      time={
                        post.created_at
                          ? new Date(post.created_at).toLocaleString("en-IN")
                          : ""
                      }
                      title={post.short_description || post.title || "Post"}
                      shortDescription={post.short_description || ""}
                      category={
                        post.category_name ||
                        post.category ||
                        post.main_category ||
                        "General"
                      }
                      mainCategory={post.main_category || "news"}
                      des={post.post_content || ""}
                      plainText={stripHtml(post.post_content || "")}
                      avater="/assets/images/user.png"
                      postimage={getUploadUrl(post.post_image)}
                      postvideo={getUploadUrl(post.post_video)}
                      youtubeUrl={post.youtube_url || ""}
                      galleryImages={(post.gallery_images || []).map(
                        (img: any) => ({
                          ...img,
                          url: getUploadUrl(img.image),
                        })
                      )}
                      tags={post.tags || []}
                      likeCount={Number(post.like_count || 0)}
                      commentCount={Number(post.comment_count || 0)}
                      shareCount={Number(post.share_count || 0)}
                      viewCount={Number(post.view_count || 0)}
                      isLiked={Boolean(post.is_liked)}
                      postType={
                        post.youtube_url
                          ? "youtube"
                          : post.post_type || post.main_category || "text"
                      }
                    onDonate={() =>
  navigate(`/donate/${post.post_id}`, {
    state: {
      donationFrom: "public",
    },
  })
}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="social-feed-state">No posts found</div>
            )}
          </div>
        </div>
      </div>

      <Popupchat />
      <Appfooter />
    </>
  );
};

export default News;